import styled from 'styled-components'

export const StyledDeleteModal = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 11;
  width: 100%;
  height: 100%;
  position: fixed;
  margin: 0;
  padding: 0 22rem;
  box-sizing: border-box;
  backdrop-filter: blur(3px);
  @media (max-width: ${(props) => props.theme.responsive.laptopL}) {
    padding: 0 20rem;
  }
  @media (max-width: ${(props) => props.theme.responsive.laptop}) {
    padding: 0 12rem;
  }
  @media (max-width: ${(props) => props.theme.responsive.tablet}) {
    padding: 0 6rem;
  }

  @media (max-width: ${(props) => props.theme.responsive.mobileL}) {
    padding: 0 2rem;
  }
`

export const StyledButtons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  @media (max-width: ${(props) => props.theme.responsive.mobileS}) {
    flex-direction: column-reverse;
  }
`

export const StyledCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  flex-direction: column;
  width: 100%;
  gap: 2rem;
  padding: 1.5rem 2rem;
  box-shadow: ${(props) => props.theme.boxShadow.shadow3};
  background-color: ${(props) => props.theme.colors.white};
  box-sizing: border-box;
`

export const StyledText = styled.div`
  display: flex;
  gap: 8px;
`
